<system-notifications [location]="'login'"></system-notifications>

<div
  *ngIf="psd2LoginBannerEnabled && step === LoginJourney.Username"
  class="psd2Banner"
  data-component="alert-message"
  [data]="{
    category: 'information',
    message:
      '<h4>How you log in and manage your account is changing</h4><p>To keep your account secure we’ll be making some changes to the way you log in and manage your account. These changes mean you may be asked to enter a one-time passcode when you log in or use certain features within Online Account Manager.</p>'
  }"
></div>

<vimeo-pop-up
  *ngIf="loginVimeoLinkEnabled"
  [showPopup]="showHelpPopup"
  [journey]="'login'"
  (closed)="hidePopup()"
>
</vimeo-pop-up>

<div class="authentication-content clearfix">
  <div
    *ngIf="alertMessage && step === LoginJourney.Bound"
    data-component="alert-message"
    [data]="{
      category: 'error',
      message: alertMessage,
      showLoginError: showLoginError,
      videoEnabled: loginVimeoLinkEnabled
    }"
    (showVideoPopup)="showPopup($event)"
  ></div>

  <div class="row horiz-line">
    <left-side-descriptions
      *ngIf="doNotDisplaySplitColumns()"
      [step]="step"
      [registerLink]="registerLink"
      [mobileNumberEnding]="mobileNumberEnding"
      [homeNumberEnding]="homeNumberEnding"
      [selectedOTPChannel]="getSelectedOtpMethod()"
    >
    </left-side-descriptions>

    <div
      *ngIf="
        [
          LoginJourney.Bound,
          LoginJourney.Unbound,
          LoginJourney.OtpDeliverySelection
        ].includes(step)
      "
      class="col-sm-6 notMyUsernameLink"
    >
      <span
        >Welcome, {{ userName }} (<a
          href="#"
          (click)="onNotMyUsername($event)"
          (click)="trackCtaActions(GTMTracking.LoginClickNotYouOTP)"
          aria-label="Not your username?"
          tabindex="2"
          >not you?</a
        >)
      </span>
    </div>

    <div class="login-form-col col-sm-6" *ngIf="doNotDisplaySplitColumns()">
      <form
        [formGroup]="loginForm"
        (ngSubmit)="submitLogin()"
        class="form-group"
        [invalidInputFocus]="loginForm"
        autocomplete="off"
      >
        <div
          data-component="validation-messages"
          [screenreaderErrorMessages]="screenreaderErrorMessages"
          [errors]="errors"
          [renderValidationSummary]="false"
        ></div>

        <div *ngIf="step === LoginJourney.Username">
          <sca-username
            #usernameComponent
            [usernameGroup]="loginForm.controls.usernameGroup"
            (isSubmittingChange)="onIsSubmittingChange($event)"
            (usernameResponseChange)="onUsernameResponseChange($event)"
            (userNameChange)="onUserNameChange($event)"
          >
          </sca-username>
        </div>

        <div *ngIf="step === LoginJourney.Bound" class="stepBound">
          <div class="form-group-control">
            <span class="passcodeLink pull-right">
              <a
                [attr.id]="forgotPasscodeLink.id"
                [routerLink]="forgotPasscodeLink.url"
                [attr.aria-label]="forgotPasscodeLink.text"
                tabindex="3"
                (click)="
                  trackCtaActions(GTMTracking.LoginClickForgottenPassCode)
                "
                >{{ forgotPasscodeLink.text }}</a
              >
            </span>
            <p class="mock-label">Enter passcode</p>
            <passcode-input
              [passcodeInputs]="passcodeInputs"
              [name]="'loginPasscode'"
              [ariaDescribedBy]="'passcodeError'"
              [labelPrefix]="'Enter your 6 digit passcode'"
              [isToggleable]="true"
              [inputTabindex]="1"
              formControlName="passcode"
              #passcodeComponent
            ></passcode-input>

            <div id="passcodeError" aria-live="polite" role="alert">
              <span
                *ngIf="formDirty && !passcodeComponent.inputted"
                class="error-msg"
                data-test-id="text-inline-required-passcode"
              >
                Passcode is required
              </span>
              <span
                *ngIf="
                  formDirty &&
                  passcodeComponent.inputted &&
                  !passcodeComponent.valid
                "
                class="error-msg"
                data-test-id="text-inline-invalid-passcode"
              >
                Passcode is invalid
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="step === LoginJourney.Unbound" class="stepUnbound">
          <div class="form-group-control">
            <span class="passcodeLink pull-right">
              <a
                [attr.id]="forgotPasscodeLink.id"
                [routerLink]="forgotPasscodeLink.url"
                [attr.aria-label]="forgotPasscodeLink.text"
                tabindex="3"
                (click)="
                  trackCtaActions(GTMTracking.LoginClickForgottenPassCode)
                "
                >{{ forgotPasscodeLink.text }}</a
              >
            </span>
            <p class="mock-label">6 digit passcode</p>
            <passcode-input
              [passcodeInputs]="passcodeInputs"
              [name]="'loginPasscode'"
              [ariaDescribedBy]="'passcodeError'"
              [labelPrefix]="'Enter your 6 digit passcode'"
              [isToggleable]="true"
              [inputTabindex]="1"
              formControlName="passcode"
              #passcodeComponent
            ></passcode-input>

            <div id="passcodeError" aria-live="polite" role="alert">
              <span
                *ngIf="formDirty && !passcodeComponent.inputted"
                class="error-msg"
                data-test-id="text-inline-required-passcode"
              >
                Passcode is required
              </span>
              <span
                *ngIf="
                  formDirty &&
                  passcodeComponent.inputted &&
                  !passcodeComponent.valid
                "
                class="error-msg"
                data-test-id="text-inline-invalid-passcode"
              >
                Passcode is invalid
              </span>
            </div>
            <ng-container *ngTemplateOutlet="errorUnbound"></ng-container>
          </div>
        </div>

        <div
          *ngIf="step === LoginJourney.OtpDeliverySelection"
          class="stepAuthcode"
        >
          <div *ngIf="mobileNumberEnding" class="form-group-control">
            <div>
              <label>Text me</label>
              <p tabindex="-1" id="text-otp">We will text the OTP to you.</p>
            </div>
            <fieldset
              class="radiolist-wrapper radiolist-stack"
              role="radiogroup"
            >
              <div class="radio-wrapper">
                <input
                  id="authcodeByText"
                  type="radio"
                  name="authCodePreference"
                  formControlName="authCodePreference"
                  [value]="otpChannel.Text"
                  [disabled]="isSubmitting"
                  data-test-id="input-preference-otpbytext"
                  aria-labelledby="text-otp authcodeByText"
                  (click)="trackCtaActions(GTMTracking.LoginSelectTextMeRadio)"
                />
                <label for="authcodeByText">
                  *******{{ mobileNumberEnding }}
                </label>
              </div>
            </fieldset>
          </div>
          <div *ngIf="homeNumberEnding" class="form-group-control">
            <div>
              <label>Call me</label>
              <p tabindex="-1" id="call-otp">
                We will ring your landline and read the OTP to you. This is an
                automated call.
              </p>
            </div>
            <fieldset
              class="radiolist-wrapper radiolist-stack"
              role="radiogroup"
            >
              <div class="radio-wrapper">
                <input
                  id="authcodeByCall"
                  type="radio"
                  name="authCodePreference"
                  formControlName="authCodePreference"
                  [value]="otpChannel.Call"
                  [disabled]="isSubmitting"
                  data-test-id="input-preference-otpbycall"
                  aria-labelledby="call-otp authcodeByCall"
                  (click)="trackCtaActions(GTMTracking.LoginSelectCallMeRadio)"
                />
                <label for="authcodeByCall">
                  ********{{ homeNumberEnding }}
                </label>
              </div>
            </fieldset>
          </div>
        </div>

        <div *ngIf="step === LoginJourney.OtpInput" class="stepOtp">
          <div class="form-group-control">
            <div>
              <label>
                Please enter your 6 digit OTP sent to: ******{{
                  getSelectedOtpMethod() ? homeNumberEnding : mobileNumberEnding
                }}
              </label>
              <otp-input
                #otpInputComponent
                fieldName="otpCode"
                [submitted]="loginButtonSubmitted"
                [ariaLabel]="otpInputLabel"
                requiredErrorMessage="Otp is Required"
              ></otp-input>
              <div aria-live="polite" role="alert">
                <p *ngIf="resendErrorMessage" class="resend-error">
                  You have reached your maximum resend limit. Please
                  <a class="resend-error" [routerLink]="contactUsLink"
                    >contact us</a
                  >
                </p>
              </div>

              <div aria-live="polite" role="alert">
                <toast
                  *ngIf="resendSuccessful"
                  [message]="resendMessage"
                ></toast>
              </div>
              <resend-countdown
                *ngIf="!resendErrorMessage"
                [resendSuccessful]="resendSuccessful"
                [text]="
                  'If your 6 digit OTP has not arrived you can request it to be'
                "
                [resendLinkText]="'resent again'"
                (onResentRequested)="resendOTPClickHandler($event)"
              ></resend-countdown>
              <ng-container *ngTemplateOutlet="errorUnbound"></ng-container>
            </div>
          </div>
        </div>
        <span
          *ngIf="
            (credentialsMessage.message || credentialsMessage.linkText) &&
            credentialsMessage.url
          "
          class="error-msg"
        >
          {{ credentialsMessage.message }}
          <a
            class="error-msg"
            [href]="credentialsMessage.url"
            data-test-id="button-credentials-message"
            [attr.data-detail]="credentialsMessage.detail"
            >{{ credentialsMessage.linkText }}</a
          >
        </span>

        <span
          *ngIf="credentialsMessage.message && !credentialsMessage.url"
          data-test-id="text-credentials-message"
          class="error-msg"
          [attr.data-detail]="credentialsMessage.detail"
        >
          {{ credentialsMessage.message }}
        </span>

        <div *ngIf="errorService.errors" aria-live="polite" role="alert">
          <div *ngFor="let error of errorService.errors">
            <div
              *ngIf="
                error.link != null &&
                (error.data != null || error.linkText != null)
              "
            >
              <span *ngIf="!error.shouldInjectLink" class="error-msg">
                {{ error.data }}
                <a
                  class="error-msg"
                  *ngIf="error.link"
                  [href]="error.link"
                  data-test-id="text-server-error-with-link"
                  >{{ error.linkText }}</a
                >
              </span>

              <span *ngIf="error.shouldInjectLink" class="error-msg">
                <span [innerHTML]="error.data"></span>
                <span
                  *ngIf="
                    (errorService.livePersonChatAvailable | async) &&
                    error.displayChatMessage
                  "
                  data-testid="lp-chat-available"
                >
                  or click the chat icon to speak to one of the team.</span
                >
              </span>
            </div>
            <span
              *ngIf="error.link == null && error.data != null"
              class="error-msg"
              data-test-id="text-server-error-without-link"
            >
              {{ error.data }}
            </span>
          </div>
        </div>

        <button
          type="submit"
          [id]="'loginStep' + step"
          [ngClass]="{
            'btn btn-primary btn-login': true,
            loading: isSubmitting
          }"
          [disabled]="!loginReady || isSubmitting"
          [attr.aria-label]="isSubmitting ? 'loading' : null"
          aria-disabled="false"
          data-test-id="button-login"
          [attr.aria-describedby]="
            (step === LoginJourney.Bound &&
              passcodeComponent &&
              !passcodeComponent.valid) ||
            credentialsMessage.srMessage
              ? 'sr-errors'
              : null
          "
        >
          {{ getTextForSubmitButton() }}
        </button>

        <div
          *ngIf="loginVimeoLinkEnabled"
          class="col-xs-12 text-center need-help-link"
        >
          <compatibility
            [minVersions]="[{ app: AppType.iOS, version: '4.2.3' }]"
          >
            <a
              data-test-id="login-help-video"
              href="#"
              (click)="showPopup($event)"
              >Need help?</a
            >
          </compatibility>
        </div>

        <div *ngIf="step === LoginJourney.OtpDeliverySelection">
          <div>
            <expander
              class="sca-expander"
              [heading]="'That\'s not my number'"
              [(isExpanded)]="notMyNumberDropdownOpen"
              (click)="trackCtaActions(GTMTracking.LoginClickNotMyNumber)"
              aria-live="polite"
              role="button"
            >
            </expander>
          </div>

          <div
            class="tab-content-full-width notmynumber-dropdown-content"
            [ngClass]="{ open: notMyNumberDropdownOpen }"
          >
            <hr />
            If we have the incorrect number(s) for you, please contact us
            <a
              [routerLink]="contactUsUrl"
              aria-describedby="customerServiceInfo"
              >customer services</a
            >
            to update your personal details.
          </div>
        </div>
      </form>
    </div>

    <div
      *ngIf="step === LoginJourney.UnboundInvalidCredentials"
      class="stepUnboundInvalidCredentials"
    >
      <h3 class="text-primary">Something has been entered incorrectly</h3>
      <p>
        We can tell you've entered a credential wrong. Please go back and review
        the details you have provided.
      </p>
      <div *ngIf="alertMessage" class="alert text-danger">
        <strong>{{ alertMessage }}</strong>
      </div>
      <button
        type="submit"
        [id]="'loginStep' + step"
        class="pull-right"
        [ngClass]="{
          'btn btn-primary btn-login': true,
          loading: isFormSubmitting()
        }"
        [disabled]="isFormSubmitting()"
        [attr.aria-label]="isFormSubmitting() ? 'loading' : null"
        aria-disabled="false"
        data-test-id="button-login"
        tabindex="6"
        (click)="submitLogin()"
      >
        Review Details
      </button>
    </div>
  </div>

  <div *ngIf="step === LoginJourney.UnableToSendOtp">
    <h3 class="text-primary">Contact us</h3>
    <p>
      We do not have a telephone number stored for you. We need a telephone
      number in order to validate your account. Please
      <a [routerLink]="contactUsUrl" aria-describedby="customerServiceInfo"
        >Contact us</a
      >
      so that we can get this updated.
    </p>
    <button
      type="submit"
      [id]="'loginStep' + step"
      class="btn btn-secondary pull-right"
      (click)="submitLogin()"
    >
      {{ getTextForSubmitButton() }}
    </button>
  </div>

  <div *ngIf="step === LoginJourney.OtpByPhone">
    <call-loading-screen
      [homeNumberEnding]="homeNumberEnding"
    ></call-loading-screen>
  </div>

  <div
    *ngIf="
      step === LoginJourney.Username &&
      mobileLinksEnabled &&
      (appStoreLink || googlePlayLink)
    "
    class="mobileAppLinks"
  >
    <hr />
    <h2>Mobile App</h2>
    <div class="row">
      <div class="col-md-7">
        <p>
          For the best experience and access to the latest features, download
          the {{ mobileAppName }} app today
        </p>
      </div>
      <div class="col-md-5 logos">
        <a
          (click)="trackCtaActions(GTMTracking.LoginClickIOSAppStoreButton)"
          *ngIf="appStoreLink"
          [href]="appStoreLink"
          target="_blank"
          title="Opens App Store page in new window"
        >
          <img
            src="{{ buildRoot }}/assets/{{ brand }}/img/app-store.svg"
            alt="App Store logo"
          />
        </a>
        <a
          (click)="trackCtaActions(GTMTracking.LoginClickAndroidAppStoreButton)"
          *ngIf="googlePlayLink"
          [href]="googlePlayLink"
          target="_blank"
          title="Opens Google Play page in new window"
        >
          <img
            src="{{ buildRoot }}/assets/{{ brand }}/img/google-play.svg"
            alt="Google play logo"
          />
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #errorUnbound>
  <div aria-live="polite">
    <div
      *ngIf="
        separatePasscodeValidation &&
        alertMessage &&
        (step === LoginJourney.Unbound || step === LoginJourney.OtpInput)
      "
      data-component="alert-message"
      [data]="{
        category: 'error',
        message: alertMessage,
        showLoginError: showLoginError,
        videoEnabled: loginVimeoLinkEnabled
      }"
      (showVideoPopup)="showPopup($event)"
    ></div>
  </div>
</ng-template>

<upl-banner *ngIf="step === LoginJourney.Username"></upl-banner>
